'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'motion/react';
import type { ReactNode } from 'react';
import { useStickyHeaderAnimation } from './use-sticky-header-animation';
type StickyHeaderProps = {
  children: ReactNode;
};
export function MotionStickyHeader(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const style = useStickyHeaderAnimation();
  let t1;
  if ($[0] !== children || $[1] !== style) {
    t1 = <motion.header className="header" style={style}>{children}</motion.header>;
    $[0] = children;
    $[1] = style;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}